var cilFilter = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M238.627,496H192V253.828l-168-200V16H480V53.612l-160,200V414.627ZM224,464h1.373L288,401.373V242.388L443.51,48H60.9L224,242.172Z' class='ci-primary'/>"];

export { cilFilter };

